export const getImageDimensions = async (
  file: File
): Promise<{ width: number; height: number }> => {
  const blob = file.slice(); // Create blob from file
  const imageBitmap = await createImageBitmap(blob);
  return { width: imageBitmap.width, height: imageBitmap.height };
};

export const getImageDimensions2 = async (
  file: File
): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    const img = new Image();
    img.crossOrigin = 'anonymous';

    img.addEventListener('load', () => {
      resolve({ width: img.width, height: img.height });
    });
    img.addEventListener('error', (event) => {
      reject(new Error(`Image reader failed to load: ${event.type}`));
    });

    const b = URL.createObjectURL(file);
    img.src = b;
  });
};
